import clsx from 'clsx'
import { CSSProperties, FC } from 'react'
import s from './ContainerV2.module.scss'

interface ContainerV2Props {
  backgroundColor?: string
  fluid?: boolean
  padded?: boolean
  children?: React.ReactNode
}
const ContainerV2: FC<ContainerV2Props> = ({
  children,
  backgroundColor,
  fluid = false,
  padded = false,
}) => {
  return (
    <div
      className={s.wrapper}
      style={
        backgroundColor
          ? ({ '--bg-color': backgroundColor } as CSSProperties)
          : undefined
      }
    >
      <div
        className={clsx(s.container, { [s.fluid]: fluid, [s.padded]: padded })}
      >
        {children}
      </div>
    </div>
  )
}

export default ContainerV2
